import type { ApiEventId } from '#/api/types/ApiTypedId';
import { FetchEndpoint } from '#/utils/endpoint/FetchEndpoint';

import type { ApiRsvpData } from './types/ApiRsvpResponse';

function mapResponse(response: ApiRsvpData) {
  return response;
}

const endpoint = new FetchEndpoint({
  urlFactory: (eventId: ApiEventId) =>
    `/data/website/events/${eventId}/rsvp-data`,
  mapResponse,
});

// Exports

export const listingApiFetchRsvpData = endpoint.createClientFetchFn();

export const useListingApiFetchRsvpData = endpoint.createUseFetchHook();
